export default __webpack_public_path__ + "static/media/National_Logo.f63f35c1.jpg";